<div class="bv-tabs__list" role="tablist">
  @for (tab of tabs; track tab; let i = $index) {
    <button
      type="button"
      class="bv-tabs__tab"
      role="tab"
      [class.bv-tabs__tab--active]="selected === i"
      [disabled]="tab.disabled"
      [attr.aria-selected]="selected === i"
      (click)="selectIndex(i)"
      >
      <ng-container
        *ngTemplateOutlet="tab.labelDir?.template || tab.defaultLabelTpl"
      ></ng-container>
    </button>
  }
</div>
@if (activeTab; as tab) {
  <div class="bv-tabs__panel" role="tabpanel" cdkScrollable>
    <ng-container *ngTemplateOutlet="tab.contentTpl"></ng-container>
  </div>
}
